<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card flex">
      <i class="pi pi-exclamation-triangle title-card-icon"></i>
      <div>
        <p class="mb-0 text-3xl title">{{'model.cepRules' | transloco}}</p>
        <p>{{'menu.descriptions.cepRules' | transloco}}</p>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex flex-column sm:flex-row justify-content-between">
            <div class="flex flex-column md:flex-row">
              <button
                *ngIf="'ROLE_ADMIN' | userHasRole"
                [label]="'common.new' | transloco"
                pButton
                pRipple
                class="md:mr-2 p-button-primary mb-2 md:mb-0"
                routerLink="new"
                icon="pi pi-plus"
              ></button>
              <button
                *ngIf="'ROLE_ADMIN' | userHasRole"
                [label]="'common.delete' | transloco"
                [disabled]="selected.length == 0"
                (click)="confirmAndDeleteSelected()"
                pButton
                pRipple
                class="md:mr-2 p-button-danger mb-2 sm:mb-0"
                icon="pi pi-trash"
              ></button>
              <p-toggleButton
                *ngIf="'ROLE_ADMIN' | userHasRole"
                [(ngModel)]="activeButtonState"
                [onLabel]="'misc.setActive' | transloco"
                [offLabel]="'misc.setInactive' | transloco"
                [disabled]="selected.length == 0"
                styleClass="w-full"
                (click)="selected.length > 0 ? changeActiveStates() : null"
                class="mb-2 sm:mb-0"
                onIcon="pi pi-check"
                offIcon="pi pi-times"
              ></p-toggleButton>
            </div>
            <div *ngIf="!filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary"
                icon="pi pi-sliders-h"
              ></button>
            </div>
            <div *ngIf="filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary filtersFilled"
                icon="pi pi-filter"
              ></button>
            </div>
          </div>
        </div>
        <p-table
          [(selection)]="selected"
          [(first)]="first"
          [(rows)]="rows"
          [value]="rules"
          [totalRecords]="totalRules"
          [responsive]="true"
          [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
          [paginator]="true"
          [rowsPerPageOptions]="[10,25,50]"
          [lazy]="true"
          (onLazyLoad)="onPageChange($event)"
          sortField="nameComplexRule"
          styleClass="p-datatable-striped"
          dataKey="nameComplexRule"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="selection-column-width" *ngIf="'ROLE_ADMIN' | userHasRole"></th>
              <th pSortableColumn="nameComplexRule">
                {{'attribute.name' | transloco}}
                <p-sortIcon field="nameComplexRule"></p-sortIcon>
              </th>
              <th pSortableColumn="ruleState">
                {{'attribute.state' | transloco}}
                <p-sortIcon field="ruleState"></p-sortIcon>
              </th>
              <th pSortableColumn="tenant.name">
                {{'model.tenant' | transloco}}
                <p-sortIcon field="tenant.name"></p-sortIcon>
              </th>
              <th pSortableColumn="organization.name">
                {{'model.organization' | transloco}}
                <p-sortIcon field="organization.name"></p-sortIcon>
              </th>
              <th pSortableColumn="lastEvaluation">
                {{'attribute.result' | transloco}}
                <p-sortIcon field="lastEvaluation"></p-sortIcon>
              </th>
              <th pSortableColumn="lastSensorEvaluated">
                {{'attribute.lastValueEvaluated' | transloco}}
                <p-sortIcon field="lastSensorEvaluated"></p-sortIcon>
              </th>
              <th pSortableColumn="evaluationDate">
                {{'attribute.evaluationDate' | transloco}}
                <p-sortIcon field="evaluationDate"></p-sortIcon>
              </th>
              <th *ngIf="'ROLE_ADMIN' | userHasRole" class="w-10rem">
                {{'common.actions' | transloco}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rule>
            <tr *ngIf="!loadingRules" class="fadein">
              <td *ngIf="'ROLE_ADMIN' | userHasRole">
                <span class="p-column-title bold">{{'common.select' | transloco}}</span>
                <p-tableCheckbox (click)="evaluateActiveButtonState()" [value]="rule"></p-tableCheckbox>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
                <a [routerLink]="rule.tenant.uuid + '/' + (rule.organization ? rule.organization.uuid : 'global')
                     + '/' + rule.nameComplexRule + '/details'">{{rule.nameComplexRule}}</a>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.state' | transloco}}</span>
                <p *ngIf="rule.ruleState === 'ACTIVE'" class="text-right md:text-left">{{'common.active' | transloco}}</p>
                <p *ngIf="rule.ruleState === 'PAUSE'" class="text-right md:text-left">{{'common.inactive' | transloco}}</p>
              </td>
              <td *ngIf="authGuardService.superAdminRequired()">
                <span class="p-column-title bold">{{'model.tenant' | transloco}}</span>
                <a
                  [routerLink]="'/management/tenants/' + rule.tenant.uuid + '/details'"
                  class="text-right md:text-left"
                >
                  {{rule.tenant.name}}
                </a>
              </td>
              <td *ngIf="!authGuardService.superAdminRequired()">
                <span class="p-column-title bold">{{'model.tenant' | transloco}}</span>
                <p class="text-right md:text-left">{{rule.tenant.name}}</p>
              </td>
              <td *ngIf="authGuardService.superAdminRequired()">
                <span class="p-column-title bold">{{'model.organization' | transloco}}</span>
                <a
                  *ngIf="rule.organization" [routerLink]="'/management/organizations/' + rule.organization.uuid + '/details'"
                  class="text-right md:text-left"
                >
                  {{rule.organization.name}}
                </a>
              </td>
              <td *ngIf="!authGuardService.superAdminRequired()">
                <span class="p-column-title bold">{{'model.organization' | transloco}}</span>
                <p class="text-right md:text-left" *ngIf="rule.organization">{{rule.organization.name}}</p>
              </td>
              <td class="m-0" *ngIf="rule.lastEvaluation != null && rule.lastEvaluation != undefined">
                <span class="p-column-title bold">{{'attribute.result' | transloco}}</span>
                <p [className]="rule.lastEvaluation ? 'success-color' : 'danger-color'">
                  <i [className]="rule.lastEvaluation ? 'pi pi-check' : 'pi pi-times'"></i>
                  {{(rule.lastEvaluation ? 'common.true' : 'common.false') | transloco}}
                </p>
              </td>
              <td class="m-0" *ngIf="rule.lastEvaluation == null || rule.lastEvaluation == undefined">
                <span class="p-column-title bold">{{'attribute.result' | transloco}}</span>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.lastValueEvaluated' | transloco}}</span>
                {{rule.lastSensorEvaluated}}&nbsp;
                <span *ngIf="rule.lastValueEvaluated">({{rule.lastValueEvaluated}})</span>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.evaluationDate' | transloco}}</span>
                {{rule.evaluationDate | customDate}}
              </td>
              <td *ngIf="'ROLE_ADMIN' | userHasRole">
                <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
                <div class="flex justify-content-end">
                  <button *ngIf="'ROLE_ADMIN' | userHasRole"
                    [routerLink]="rule.tenant.uuid + '/' + (rule.organization ? rule.organization.uuid : 'global')
                     + '/' + rule.nameComplexRule + '/edit'"
                    pButton
                    pRipple
                    class="p-button-rounded btn-primary-light mr-2"
                    icon="pi pi-pencil"
                  ></button>
                  <button
                    *ngIf="'ROLE_ADMIN' | userHasRole"
                    (click)="confirmAndDelete(rule)"
                    class="p-button-rounded btn-danger-light"
                    icon="pi pi-trash"
                    pButton
                    pRipple
                  ></button>
                </div>
              </td>
            </tr>
            <tr *ngIf="loadingRules" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
              <td *ngIf="'ROLE_ADMIN' | userHasRole" class="row-height selection-column-width">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td *ngIf="'ROLE_OPERATOR' | userHasRole" class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between"
                 *ngIf="totalRules == 0">{{'pagination.empty' | transloco}}</div>
            <div class="flex align-items-center justify-content-between" *ngIf="totalRules > 0">
              {{'pagination.showing' | transloco}} {{first + 1}}
              {{'pagination.to' | transloco}} {{(first + rows) >= totalRules ? totalRules : (first + rows)}}
              {{'pagination.of' | transloco}} {{totalRules}}
              {{(totalRules > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
    <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
    <div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="name">{{'attribute.name' | transloco}}</label>
        </div>
        <div class="col-12 form-field">
          <input
            [(ngModel)]="currentFilters.nameComplexRule"
            [focus]="filtersVisible"
            (keyup.enter)="filtersVisible = false; applyFilters()"
            pInputText
            appAutoFocus
            class="w-full"
            id="name"
            type="text"
          >
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label>{{'attribute.state' | transloco}}</label>
        </div>
        <div class="col-12">
          <div class="p-field-radiobutton margin-top">
            <p-radioButton
              [(ngModel)]="currentFilters.ruleState"
              [label]="'misc.allTypes' | transloco"
              class="mr-3"
              name="ruleState"
              value=""
            ></p-radioButton>
          </div>
          <div class="p-field-radiobutton margin-top">
            <p-radioButton
              [(ngModel)]="currentFilters.ruleState"
              [label]="'misc.activeOnly' | transloco"
              name="ruleState"
              value="ACTIVE"
            ></p-radioButton>
          </div>
          <div class="p-field-radiobutton margin-top">
            <p-radioButton
              [(ngModel)]="currentFilters.ruleState"
              [label]="'misc.inactiveOnly' | transloco"
              name="ruleState"
              value="PAUSE"
            ></p-radioButton>
          </div>
        </div>
      </div>
      <div class="col-12" *ngIf="authGuardService.superAdminRequired()">
        <div class="col-12 form-field">
          <label for="tenant">{{'model.tenant' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-multiSelect
            [(ngModel)]="currentFilters.tenantUuids"
            [placeholder]="'select.generic' | transloco"
            [options]="tenants"
            [filter]="true"
            styleClass="w-full"
            id="tenant"
            optionLabel="name"
            optionValue="uuid"
            filterBy="name"
            display="chip"
            appendTo="body"
          ></p-multiSelect>
        </div>
      </div>
      <div class="col-12">
        <p-button
          [label]="'common.filter' | transloco"
          (onClick)="filtersVisible = false; applyFilters()"
          styleClass="p-button-primary mx-2 mt-2"
          type="button"
        ></p-button>
        <p-button
          [label]="'common.clear' | transloco"
          (click)="resetFilters(); filtersVisible = false; applyFilters()"
          styleClass="p-button-danger"
          type="button"
        ></p-button>
      </div>
    </div>
  </p-sidebar>
</div>
